module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/home-guess-ccdd4ea7f6dfb409c58d815c89c0733e.jpg";